import { render, staticRenderFns } from "./jisan.vue?vue&type=template&id=1504d578&scoped=true&"
import script from "./jisan.vue?vue&type=script&lang=js&"
export * from "./jisan.vue?vue&type=script&lang=js&"
import style0 from "./jisan.vue?vue&type=style&index=0&id=1504d578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1504d578",
  null
  
)

export default component.exports